import { useLanguage } from '../contexts/LanguageContext';
import no from './no';
import en from './en';

const DICT = { no, en };

/**
 * Returns the full translation tree for the active language.
 * Usage:
 *   const t = useT();
 *   return <h1>{t.hero.title.line1}</h1>;
 *
 * Falls back to Norwegian if the active language is not supported here.
 */
export const useT = () => {
  const { language } = useLanguage();
  return DICT[language] || DICT.no;
};

export default useT;
